import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import ColorOption from "../ColorOption";
import VehicleVideoPopup from "../VehicleVideoPopup";
import { useAppData } from "../../context/Contexts";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    applyPriceTest26CoverageOverride,
    formatMoney,
    getComponentSkus,
    getCurrency,
    getNewPartNumber,
    getOfferPrice,
    handleColorChange,
    isColorHiddenByCheckAvailability,
    isColorHiddenBySkuMappingAvailability,
    parseSeatValue,
    sanitizeHtml,
} from "../../helpers/helpers";
import { getVideoUrlForPartNumber } from "../../config/videoMapping";

// Front-only part numbers use a "00" prefix, which has no entry in videoMapping —
// fall back to the Bundle/Rear part number's video for those vehicles too, since
// it's the same vehicle install demo regardless of which seats were ordered.
function getVehicleVideoUrl(currentAppData): string | undefined {
    if (!currentAppData) return undefined;
    const ownUrl = getVideoUrlForPartNumber(getNewPartNumber(currentAppData));
    if (ownUrl) return ownUrl;
    return getVideoUrlForPartNumber(getNewPartNumber({ ...currentAppData, seat: 'Bundle' }));
}
import { calculateShipByDate, DEFAULT_SHIP_BY_DAYS, getMaxShipByDate } from "../../utils/shippingDate";
import { useHolidaysQuery } from "../../services/HolidaysService";

export default function Step2New(props) {
    const stepNumber = props.stepNumber ?? 2;
    const { currentAppData, setCurrentAppData } = useAppData();
    const [opts, setOpts] = useState([]);
    const [price, setPrice] = useState('');

    const [comparePrice, setComparePrice] = useState('');
    const [comparePrice1, setComparePrice1] = useState('');
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [savings1, setSavings1] = useState<undefined | string>(undefined);
    const [paymentTerms, setPaymentTerms] = useState('');
    const [videoPopupOpen, setVideoPopupOpen] = useState(false);

    let seat = '';

    // console.log('currentAppData.selectedId', currentAppData.selectedId);

    useEffect(() => {
        let product = currentAppData.originalProduct;
        if (currentAppData.check && currentAppData.check.compatibility_custom !== 'N') {
            product = currentAppData.product;
        }

        // console.log('product', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.id.replace('gid://shopify/ProductVariant/', '') === '' + currentAppData.selectedId) : [];
        // console.log('filtered', filtered);
        if (filtered.length > 0) {
            const seatForPriceTest = filtered[0].node.selectedOptions?.filter(o => o.name === 'Seats')[0]?.value;
            applyPriceTest26CoverageOverride(filtered[0].node, seatForPriceTest, currentAppData);

            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            setPrice(currency + '' + filtered[0].node.priceV2.amount);

            if (filtered[0].node.compareAtPrice) {
                setComparePrice(currency + '' + filtered[0].node.compareAtPrice.amount);
                setComparePrice1(filtered[0].node.compareAtPrice.amount);
                setSavings1(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount));
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                if (window.scs_show_earlybf_section || window.scs_father_day_2026) {
                    setSavings(currency + '' + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }


    }, [currentAppData.selectedId]);

    useEffect(() => {
        // Don't update colors while fetching compatibility check
        if (currentAppData?.isFetchingCheck) {
            return;
        }

        const product = currentAppData.check && (currentAppData.check.compatibility === 'N' || currentAppData.check.compatibility === 'A')
            ? currentAppData.product
            : currentAppData.originalProduct;
        if (!product) {
            return;
        }
        // console.log('product', product);
        // console.log('currentAppData step3', currentAppData);


        seat = parseSeatValue(currentAppData.seat, currentAppData?.check?.compatibility_custom);

        const check = currentAppData.check;
        if (!seat || seat === '') {
            // setCurrentAppData(prevState => {
            //     return {...prevState, step: 2}
            // })
            return;
        }
        if (!product || !product?.variants) {
            return;
        }

        const availableColors1 = product.variants.edges
            //.filter(v => v.node.availableForSale === true)
            .filter(v => v.node.selectedOptions
                .filter(el => el.name === 'Seats' && el.value === seat).length > 0);

        // console.log('availableColors1:', availableColors1);

        //console.log('currentAppData', currentAppData);

        const skuMappingFilteredColors = availableColors1.filter(v => {
            const color = v.node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;
            return !isColorHiddenBySkuMappingAvailability(currentAppData, seat, color) &&
                !isColorHiddenByCheckAvailability(currentAppData, seat, color);
        });

        const availableColors = (check && check.compatibility && check.compatibility !== 'N' && check.compatibility !== 'A' && check.compatibility !== 'Y') ? skuMappingFilteredColors.filter(v => {
            const color = v.node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;
            const availableInCheck = check?.availability?.[seat]?.[color] === true;
            const availableInBiz2 = currentAppData?.sku_mapping_availability?.[seat]?.[color] === true;
            return availableInCheck || availableInBiz2;
        }) : skuMappingFilteredColors;

        //DONE: filter availableColors by Sku to check data from parts inventory
        // console.log('availableColors222:', availableColors);

        setOpts(availableColors);

        const isCurrentColorAvailable = availableColors.some(v => {
            const color = v.node.selectedOptions.find(ep => ep.name === 'Color')?.value;
            return color === currentAppData.color;
        });

        //const flagx = !isCurrentColorAvailable;

        //console.log('isCurrentColorAvailable:', isCurrentColorAvailable, 'flagx:', flagx);

        if (availableColors.length > 0 ) {
            if (!isCurrentColorAvailable) {
                //console.log('current color not available, setting to first available color');
                const val = availableColors[0].node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;
                const id = availableColors[0].node.id.replace('gid://shopify/ProductVariant/', '');

                setCurrentAppData(previousState => {
                    return { ...previousState, color: val, selectedId: id };
                });
                return;
            } else {
                const val = availableColors.find(v => v.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === currentAppData.color).length > 0)?.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === currentAppData.color)[0]?.value;
                const id = availableColors.find(v => v.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === currentAppData.color).length > 0)?.node.id.replace('gid://shopify/ProductVariant/', '');

                setCurrentAppData(previousState => {
                    return { ...previousState, selectedId: id };
                });
            }
        }

    }, [currentAppData.check, currentAppData.product, currentAppData.originalProduct,
    currentAppData.seat, currentAppData.year, currentAppData.make, currentAppData.model, currentAppData.isFetchingCheck, currentAppData.sku_mapping_availability]);

    const handleChange = (e) => {
        const id = e.target.dataset.id.replace('gid://shopify/ProductVariant/', '');
        const newColor = e.target.value;
        // console.log('selected id', id);
        const id1 = handleColorChange(currentAppData, newColor, id, setCurrentAppData);

        setCurrentAppData(prevState => {
            return { ...prevState, color: newColor, selectedId: id1 }
        })
    }

    useEffect(() => {
        const el = document.querySelector('#payment_terms');
        setPaymentTerms(el ? el.innerHTML : '');
    }, []);
    //DONE: fix savings

    function getSkuFromId(selectedId) {
        if (!selectedId) {
            return '';
        }
        const filtered = currentAppData?.product?.variants?.edges.filter(v => v.node.id.replace('gid://shopify/ProductVariant/', '') == selectedId);
        if (filtered.length == 0) {
            return '';
        }
        return filtered[0].node?.sku;
    }

    const hasAlert = function (currentAppData) {
        if (window.scs_bulk_alert_colors) {
            let hasAlert = false;
            window.scs_bulk_alert_colors.forEach((color) => {
                const colorParts = color.split(';');
                // console.log(colorParts);
                const sku = colorParts[0];
                const alert = colorParts[1];
                // console.log('sku:', getSkuFromId(currentAppData.selectedId));
                if (getSkuFromId(currentAppData.selectedId) === sku) {
                    hasAlert = true;
                }
            })
            // console.log('hasAlert:', hasAlert);
            if (hasAlert) {
                return true;
            }
        }

        return window.scs_show_color_alert && window.scs_alert_colors && window.scs_alert_colors.includes(currentAppData.color) &&
            ['Universal Back Bench', 'Bundle'].includes(currentAppData.seat);
    }

    const getAlert = function (currentAppData) {
        if (window.scs_bulk_alert_colors) {
            let hasAlert = '';
            window.scs_bulk_alert_colors.forEach((color) => {
                const colorParts = color.split(';');
                const sku = colorParts[0];
                const alert = colorParts[1];
                if (getSkuFromId(currentAppData.selectedId) === sku) {
                    hasAlert = alert;
                }
            })
            if (hasAlert != '') {
                return hasAlert.replace('[item]', currentAppData.color);
            }
        }

        return window.scs_product_alert_text?.replace('[item]', currentAppData.color);
    }
    //console.log('color:', currentAppData.color);

    const holidaysQuery = useHolidaysQuery();

    const shipByInfo = useMemo(() => {
        if (!currentAppData?.color || !currentAppData?.product?.variants) return null;
        const parsedSeat = parseSeatValue(currentAppData.seat, currentAppData?.check?.compatibility_custom);
        const selectedVariant = currentAppData.product.variants.edges.find(
            (v: any) =>
                v.node.selectedOptions.some(
                    (o: any) => o.name === 'Color' && o.value === currentAppData.color
                ) &&
                v.node.selectedOptions.some(
                    (o: any) => o.name === 'Seats' && o.value === parsedSeat
                )
        );
        const sku = selectedVariant?.node?.sku;
        const componentSkus = getComponentSkus(currentAppData);
        const holidays = holidaysQuery.data ?? [];
        const result = getMaxShipByDate([sku, ...componentSkus], undefined, holidays);
        if (result) return result;
        return window.scs_ship_by_date_format2 ? calculateShipByDate(String(DEFAULT_SHIP_BY_DAYS), undefined, holidays) : null;
    }, [currentAppData?.color, currentAppData?.seat, currentAppData?.product, currentAppData?.check, currentAppData?.sku_mapping_availability, holidaysQuery.data]);

    // "?open_video=1" auto-opens the "See these seat covers in your vehicle" popup
    // once its video is actually resolvable — mirrors the vehicle_video_link_btn's
    // own onClick. Declared before the early-return below so the hook always runs.
    const autoOpenVideoRef = useRef(false);
    useEffect(() => {
        if (autoOpenVideoRef.current) return;
        if (new URLSearchParams(window.location.search).get('open_video') !== '1') return;
        const url = getVehicleVideoUrl(currentAppData);
        const showLink = window.scs_see_these_seat_covers_in_your_vehicle === true && !!url;
        if (!showLink) return;
        autoOpenVideoRef.current = true;
        setVideoPopupOpen(true);
    }, [currentAppData]);

    // In biz2 stepper, hide this step until the previous steps are done.
    const isBiz2Stepper = !!(window.scs_new_design_2026 && window.scs_biz2);
    if (isBiz2Stepper && (currentAppData?.step ?? 0) < stepNumber) return (
        <section className={`step_2 ${styles.section__step} ${styles.section_locked} ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''}`} id="step_2">
            <h2><span className={`${styles.section__step_no}`}>{stepNumber}</span></h2>
            <div className={`${styles.selector_wrapper}`}>
                <strong><span className={`${styles.section__step_no}`}>{stepNumber}</span>Color</strong>
            </div>
        </section>
    );
    const isStepActive = isBiz2Stepper ? currentAppData?.step == stepNumber : currentAppData?.step == 2;

    const vehicleVideoUrl = getVehicleVideoUrl(currentAppData);
    const showVehicleVideoLink =
        window.scs_see_these_seat_covers_in_your_vehicle === true && !!vehicleVideoUrl;

    return (<>

        <section
            className={`step_2 ${styles.section__step} ${isStepActive ? styles.section_active : ''} ${window.scs_new_design_2026 ? styles.scs_new_design_2026 : ''}`}
            id="step_2">
            <h2><span className={`${styles.section__step_no} ${!isStepActive ? styles.section__step_no_done : ''}`}>{stepNumber}</span></h2>

            <div className={`${styles.selector_wrapper}`}>
                <strong><span className={`${styles.section__step_no} ${!isStepActive ? styles.section__step_no_done : ''}`}>{stepNumber}</span>Color{currentAppData.color ? ` - ${currentAppData.color}` : ''}</strong>

                {window.scs_ship_by_date_format2 && currentAppData?.seat ? (
                    <div className={localStyles.shipping_estimate_prompt}>
                        <span className={localStyles.shipping_estimate_prompt_highlight}>In high demand:</span> Select a color below to view expected ship time
                    </div>
                ) : null}

                <div className={`${localStyles.color_selector}`} style={{ position: 'relative', opacity: currentAppData?.configurator_complete === false ? 0.4 : 1, pointerEvents: currentAppData?.configurator_complete === false ? 'none' : undefined }}>
                    {opts && opts.map(el => {
                        const val = el.node.selectedOptions.filter(ep => ep.name === 'Color')[0].value;

                        //console.log(currentAppData.color, '==', val, currentAppData.color === val);

                        return (<ColorOption key={`${props.id}-${el.node.id}`}
                            masterId={props.id}
                            value={val}
                            id={`${el.node.id}`} name="Color" onChange={handleChange}
                            checked={currentAppData.color === val} />);
                    })}
                    {currentAppData?.isFetchingCheck || (opts.length === 0 && !!currentAppData?.seat) ? (
                        <div className={localStyles.skeleton_wrapper} style={{ position: 'absolute', top: 0, left: 0, right: 0, background: 'rgba(255,255,255,0.8)', zIndex: 10 }}>
                            {[...Array(7)].map((_, i) => (
                                <div key={`skeleton-${i}`} className={localStyles.skeleton} />
                            ))}
                        </div>
                    ) : null}
                </div>

                {showVehicleVideoLink ? (
                    <button
                        type="button"
                        className={`${localStyles.vehicle_video_link} vehicle_video_link_btn`}
                        onClick={() => setVideoPopupOpen(true)}
                    >
                        See these seat covers in your vehicle
                    </button>
                ) : null}


                <div className={`${styles.summary}`} style={{ display: "none" }}>

                </div>

                {savings && !window.scs_show_color_alert && !window.scs_black_friday_2025 ? (
                    <div className={`${styles.savings}`}>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_953_3054)">
                                <path
                                    d="M13.7499 0.110046H8.55454C8.21086 0.110046 7.7305 0.309154 7.48767 0.551803L0.364771 7.67466C-0.12159 8.16048 -0.12159 8.95698 0.364771 9.4422L5.66835 14.7456C6.15361 15.2314 6.94934 15.2314 7.43534 14.745L14.5582 7.62328C14.8008 7.38067 15 6.89955 15 6.55659V1.3601C15 0.672725 14.4373 0.110046 13.7499 0.110046ZM11.2498 5.11007C10.5594 5.11007 9.99975 4.54981 9.99975 3.86002C9.99975 3.16909 10.5594 2.60997 11.2498 2.60997C11.9402 2.60997 12.5 3.16909 12.5 3.86002C12.5001 4.54981 11.9402 5.11007 11.2498 5.11007Z"
                                    fill="black" />
                            </g>
                            <defs>
                                <clipPath id="clip0_953_3054">
                                    <rect width="15" height="15" fill="white" transform="translate(0 0.109924)" />
                                </clipPath>
                            </defs>
                        </svg>
                        You Saved: <span
                            className={`${styles.savings_price}`} data-testid="savings-price">{savings}</span> ({(savings1 / comparePrice1 * 100).toFixed(0)}%)
                    </div>
                ) : ''}
                {window.scs_ship_by_date_format2 && currentAppData?.color && shipByInfo ? (
                    <div className={`${styles.stock_alert}`} style={{ margin: 0 }}>
                        <div className={`${styles.text}`} style={{ display: "block" }}>
                            Your selection: <span style={{ fontWeight: 700, fontSize: "1.15em" }}>{currentAppData.color}</span> will ship by <span style={{ fontWeight: 700, fontSize: "1.15em" }}>{shipByInfo.formatted}</span>
                        </div>
                    </div>
                ) : hasAlert(currentAppData) ? (<div className={`${styles.stock_alert}`}>
                    <div className={`${styles.text}`}>{getAlert(currentAppData)}</div>
                </div>) : ''}

                <div className={`${localStyles.payment_terms}`} style={{ display: "none" }} dangerouslySetInnerHTML={{ __html: sanitizeHtml(paymentTerms) }}></div>
            </div>

        </section>

        {showVehicleVideoLink && vehicleVideoUrl ? (
            <VehicleVideoPopup
                open={videoPopupOpen}
                videoUrl={vehicleVideoUrl}
                onClose={() => setVideoPopupOpen(false)}
            />
        ) : null}
    </>);
}
